import { render, staticRenderFns } from "./DynamicFormV2.vue?vue&type=template&id=02f51bd8&scoped=true&"
import script from "./DynamicFormV2.vue?vue&type=script&lang=js&"
export * from "./DynamicFormV2.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormV2.vue?vue&type=style&index=0&id=02f51bd8&scoped=true&lang=css&"
import style1 from "./DynamicFormV2.vue?vue&type=style&index=1&id=02f51bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f51bd8",
  null
  
)

export default component.exports